/**
 * Stable `code` of the checkout refusals every payment button reacts to the
 * same way, whatever the endpoint (`/subscription/checkout`, `/activate`,
 * `/stripe-hosted-payment`, the public billing link).
 */
export const SUBSCRIPTION_ERROR_CODE = {
  /**
   * 409: Stripe already holds a live subscription (or a completed payment) for
   * this customer that the tenant does not show yet — a late webhook or a
   * second tab. The server has reconciled what it could; the page must
   * refetch and never open a second checkout.
   */
  activationInProgress: 'subscription_activation_in_progress',
} as const;
